import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import { selectListItems } from '../../../../../../redux/library/selector';
import { logisticsOrders } from '../../../../../../redux/logistics-orders/action';
import { jobs } from '../../../../../../redux/jobs/action';
import { customers } from '../../../../../../redux/customers/action';
import PageLoader from '../../../../../../components/PageLoader';
import OrderComponent from '../components/order.component';
import { selectLogisticsOrdersQueryItems } from '../../../../../../redux/logistics-orders/selector';
import { selectJobsListItems } from '../../../../../../redux/jobs/selector';
import { selectCustomersListItems } from '../../../../../../redux/customers/selector';

const ManagementLogisticsOrder = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const orderQuery = useSelector(selectLogisticsOrdersQueryItems)
  const jobItemsData = useSelector(selectJobsListItems)
  const customerItemsData = useSelector(selectCustomersListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const libraryData = useSelector(selectListItems)
  const [
    selectedOrder,
    setSelectedOrder
  ] = useState<any>({})


  const fetchOrderById = () => {
    dispatch(logisticsOrders.query({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/logistics-orders/fetch-detail`, entity: 'logisticsOrders', jsonData: {
        Context: {},
        Records: [
          {
            Id: parmas?.id
          }
        ]

      }
    })).then(() => {
      setIsQuery(true)
    }).then(() => {
      setIsLoading(false)
    })




  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedOrder({ ...selectedOrder, [field]: event });
  }


  useEffect(
    () => {

      dispatch(customers.list({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/sales/crm/logistics-customers/list`,
        entity: 'customers',
        jsonData: {}
      }))

        .then(() => {
          if (parmas?.id > 0) {
            fetchOrderById()
            setIsLoading(false)
          } else {
            setIsLoading(false)
          }
        })
    },
    []
  )
  useEffect(
    () => {
      if (isQuery) {
        setSelectedOrder(orderQuery?.result?.items)
      }
    },
    [isQuery]
  )

  const handleFormSubmit = async (event: any) => {

  }

  const back = () => {
    navigate('/management/logistics/transport/logistics-orders')
  }

  return (
    <>
      {isLoading ? <PageLoader /> :
        <OrderComponent
          orderStatus={libraryData?.result?.LogisticsOrderStatus}
          NetworkType={libraryData?.result?.NetworkType}
          customers={customerItemsData?.result?.items}
          selectedOrder={selectedOrder}
          onInnerBasicFormChange={handleInnerFormChange}
          back={back}
          handleFormSubmit={handleFormSubmit}
        />
      }
    </>
  )

}

export default ManagementLogisticsOrder;